import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { CartDrawer } from "@/components/CartDrawer";
import { track } from "@/lib/api";

export default function PublicLayout() {
  const location = useLocation();

  useEffect(() => {
    track("page_view", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#050505] text-zinc-100">
      <SiteHeader />
      <main className="pt-16">
        <Outlet />
      </main>
      <SiteFooter />
      <CartDrawer />
    </div>
  );
}
